// Module
var code = "<div data-bind=\"css: _imageHeight\" data-control-type=\"image-control\" class=\"FormDesignerView form-designer-view clearfix control-prev-image form-standart-control new-control\"> <img class=\"image-item\" src=\"/img/Custom/pic.jpg\" alt=\"ImageControl\"/> </div>\t";
// Exports
export default code;